import { DateTime } from 'luxon';
import isBeforeDay from './isBeforeDay';
import isSameDay from './isSameDay';

export default function isAfterDay(a, b) {
    if (!(a instanceof DateTime) || !(b instanceof DateTime)) return false;

    return !isBeforeDay(a, b) && !isSameDay(a, b);
}
